<template>
  <div id="container" ref="containerRef">
    <div id="title">
      <svg id="title-svg" viewBox="0 0 160 20">
        <g>
          <text
            class="title-text"
            x="0"
            y="12"
            font-family="SegoeUI, Segoe UI"
            font-size="13"
            font-weight="normal"
            fill="#00413B"
          >
            Select Hypotension Colors
          </text>
        </g>
      </svg>
    </div>
    <div id="radio-set-grid" class="grid-bg">
      <HypoRadioSet
        ref="radioset"
        :options="options"
        v-model="selected"
      ></HypoRadioSet>
    </div>
    <svg id="close" viewBox="0 0 40 39" @click="clickClose">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g>
          <rect id="bg" fill="#00413B" x="0" y="0" width="100%" height="100%" />
          <polygon
            id="Path"
            fill="#FFFFFF"
            points="9 2 20.013 15.845 31.0275928 2 36.0275928 2 22.509 18.982 36.0275928 35.975305 31.0458031 35.975305 20.013 22.116 8.98178971 35.975305 4 35.975305 17.518 18.982 4 2"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import HypoRadioSet from '../components/HypoRadioSet'

export default {
  name: 'HypoConfigDialog',
  data() {
    return {
      selected: {
        id: 1,
        checked: true,
        colors: ['#C5EECD', '#C4C4C4', '#707070']
      },
      options: [
        { id: 1, checked: true, colors: ['#C5EECD', '#C4C4C4', '#707070'] },
        { id: 2, checked: false, colors: ['#C5EECD', '#707070', '#000000'] }
      ]
    }
  },
  components: {
    HypoRadioSet
  },
  methods: {
    clickClose() {
      this.$emit('close-dialog')
    }
  },
  watch: {
    selected(newValue, oldValue) {
      this.$emit('change-hypo-colors', newValue)
    }
  }
}
</script>

<style scoped>
text {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
#container {
  position: relative;
  background-color: white;
  border: 2px solid #00413b;
  display: grid;
  box-sizing: border-box;
  padding: 1%;
  grid-template-columns: 100%;
  grid-template-rows: 20% 80%;
}

#close {
  position: absolute;
  width: 8%;
  height: 13%;
  top: 0;
  right: 0;
  background-color: #00413b;
}

.grid-bg {
  background: #efefef;
  border: 1px solid #808080;
}

#title {
  grid-row: 1;
  grid-column: 1;
  display: flex;
  justify-content: flex-start;
}

#title-svg {
  height: 100%;
}

#radio-set-grid {
  grid-row: 2;
  box-sizing: border-box;
  padding-left: 13%;
  padding-right: 17%;
}
</style>
